import styled from 'styled-components';

export const Content = styled.div`
  padding: 1rem;
`;

export const LocationDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding-bottom: 1rem;
  color: ${(p) => p.theme.colors.text};
`;

export const AddressTitle = styled.strong`
  font-size: 1rem;
`;

export const AddressLine = styled.span`
  line-height: 1.4;
`;

export const LocationMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1rem;
  font-size: 0.9rem;
  opacity: 0.85;
`;

export const MapFrame = styled.div`
  position: relative;
  width: 100%;
  height: min(55vh, 440px);
  min-height: 280px;
  overflow: hidden;
  border-radius: 0.5rem;
  background: ${(p) => p.theme.colors.surface};

  .order-location-map {
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
  }
`;
